import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import NavbarAccount from "./NavbarAccount";
import { Dropdown } from "react-bootstrap";
import NavbarNotifications from "./NavbarNotifications";
import { NavbarSearchIcon, NavbarSearch } from "./NavbarSearch";

const Navbar = () => {
  const [searchActive, setSearchActive] = useState(false);
  let location = useLocation();

  return (
    <>
      <nav
        className="navbar navbar-expand-lg bg-primary w-100 color mt-0  navbar-top"
        // data-bs-theme="dark"
      >
        <div className="container">
          <div className="d-flex flex-row  d-lg-none">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <NavbarSearchIcon
              searchActive={searchActive}
              setSearchActive={setSearchActive}
              className="ms-3 mt-1"
            />
          </div>

          <Link className="navbar-brand" to="/">
            <img src={"/logo_white.svg"} alt="Curso.run" className="me-2" />
            <img src={"/curso_white.png"} alt="Curso.run" />
          </Link>
          <div className="d-flex flex-row  d-lg-none">
            <NavbarNotifications className="me-3 mt-1" />
            <NavbarAccount />
          </div>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/"
                >
                  Accueil
                </Link>
              </li>
              <Dropdown className="nav-item me-4">
                <Dropdown.Toggle className="nav-link">Athlètes</Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item>
                    <Link to="/athletes">Tous athlètes</Link>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Link to="/athletes/subscriptions">Mes abonnements</Link>
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <Link to="/clubs">Clubs</Link>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Link to="/groups">Groupes</Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="nav-item me-4">
                <Dropdown.Toggle className="nav-link">Outils</Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item>
                    <Link to="/tools/pace-calculator">
                      Calculateur d'allure
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Link to="/tools/race-prediction">
                      Prédiction de courses
                    </Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {/* <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname.indexOf("/athletes") !== -1 ? "active" : ""
                }`}
                to="/athletes"
              >
                Athlètes
              </Link>
            </li> */}
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname.indexOf("/competitions") !== -1
                      ? "active"
                      : ""
                  }`}
                  to="/competitions"
                >
                  Compétitions
                </Link>
              </li>
              {/* <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname.indexOf("/clubs") !== -1 ? "active" : ""
                }`}
                to="/clubs"
              >
                Clubs
              </Link>
            </li> */}
            </ul>
          </div>
          <div className="d-flex flex-row d-none d-lg-flex">
            <NavbarSearchIcon
              searchActive={searchActive}
              setSearchActive={setSearchActive}
              className="me-3 mt-1"
            />
            <NavbarNotifications className="me-3 mt-1" />
            <NavbarAccount />
          </div>
        </div>
      </nav>
      {searchActive && <NavbarSearch setSearchActive={setSearchActive} />}
    </>
  );
};

export default Navbar;
